import { useMemo, Fragment } from 'react'
import { Switch } from '@chakra-ui/react'
import { UseFormReturn } from 'react-hook-form'

import { FormItem } from 'components'
import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import MinimunAnxMaximunValidators from './components/MinimunAnxMaximunValidators'
import CharactersLimitValidator from './components/CharactersLimitValidator'
import DateValidators from './components/DateValidators'
import ExtensionsValidator from './components/ExtensionsValidator'
import HourValidators from './components/HourValidators'
import MultipleFilesValidator from './components/MultipleFilesValidator'

type ValidationsProps = {
  questionKind?: string
  formMethods: UseFormReturn<CustomFormQuestion>
}

export default function Validations({ formMethods, questionKind }: ValidationsProps) {
  const showMinAndMaxValidators = useMemo(() => {
    const kinds = ['INTEGER', 'DECIMAL', 'SINGLE_FILE_UPLOAD', 'MULTIPLE_FILE_UPLOAD', 'MULTIPLE_SELECTION_BOX']
    return kinds.includes(questionKind as string)
  }, [questionKind])

  const showFileExtensionsManagementValidators = useMemo(() => {
    const kinds = ['SINGLE_FILE_UPLOAD', 'MULTIPLE_FILE_UPLOAD']
    return kinds.includes(questionKind as string)
  }, [questionKind])

  const showMultipleFilesValidator = useMemo(() => {
    const kinds = ['MULTIPLE_FILE_UPLOAD']
    return kinds.includes(questionKind as string)
  }, [questionKind])

  const showDateValidator = useMemo(() => {
    const kinds = ['DATE']
    return kinds.includes(questionKind as string)
  }, [questionKind])

  const showHourValidator = useMemo(() => {
    const kinds = ['TIME']
    return kinds.includes(questionKind as string)
  }, [questionKind])

  const showMaxCharactersValidator = useMemo(() => {
    const kinds = ['SHORT_TEXT', 'LONG_TEXT']
    return kinds.includes(questionKind as string)
  }, [questionKind])

  return (
    <Fragment>
      <FormItem label="Questão obrigatória">
        <Switch {...formMethods.register('is_required')} />
      </FormItem>

      {showFileExtensionsManagementValidators && (
        <FormItem
          label="Permitir uso da câmera para realizar o envio do arquivo"
          helperText="ATENÇÃO! Ao selecionar essa opção, só serão permitidos os envios de arquivos do tipo imagem (JPEG, PNG e etc)."
        >
          <Switch {...formMethods.register('validation.have_camera')} />
        </FormItem>
      )}

      {showMinAndMaxValidators && <MinimunAnxMaximunValidators formMethods={formMethods} questionKind={questionKind} />}

      {showHourValidator && <HourValidators formMethods={formMethods} />}

      {showDateValidator && <DateValidators formMethods={formMethods} />}

      {showMultipleFilesValidator && <MultipleFilesValidator formMethods={formMethods} />}

      {showFileExtensionsManagementValidators && <ExtensionsValidator formMethods={formMethods} />}

      {showMaxCharactersValidator && <CharactersLimitValidator formMethods={formMethods} />}
    </Fragment>
  )
}
